//
// Module for the DROP Enrollment wizard's Eligibility step's Detail partial view
//
rs.module("participant/benefit/setup/drop/wizard/eligibilitystepdetail",

    ["controls/components/event-banner", "common/visibility"],

    function (eventBanner, visibility) {

        // Initialize the module
        function initialize(jsSelectors, defaultValues, codeValues, payOptionMethodDictionary, variablePayOptionKeys) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var payOptionSelect = stepContainer.js(jsSelectors.payOptionSelect);
            var payOptionChildContainer = stepContainer.js(jsSelectors.payOptionChildContainer);
            var payOptionPercentInput = stepContainer.js(jsSelectors.payOptionPercentInput);
            var payOptionYearsInput = stepContainer.js(jsSelectors.payOptionYearsInput);
            var payOptionPaymentsInput = stepContainer.js(jsSelectors.payOptionPaymentsInput);
            var payOptionTerminationDateInput = stepContainer.js(jsSelectors.payOptionTerminationDateInput);
            var payOptionTerminationDateHidden = stepContainer.js(jsSelectors.payOptionTerminationDateHidden);
            var beneficiariesContainer = stepContainer.js(jsSelectors.beneficiariesContainer);

            // Hookup payOptionSelect change event
            payOptionSelect.change(payOptionChange);

            // Hookup payOptionYearsInput and payOptionPaymentsInput change events
            payOptionYearsInput.on('input', payOptionYearsChange);
            payOptionPaymentsInput.on('input', payOptionPaymentsChange);

            // Pay Option change event
            function payOptionChange() {

                // Get selected Pay Option Key
                var selectedPayOptionKey = payOptionSelect.val();

                // Get corresponding selected Pay Option Method
                var selectedPayOptionMethod = payOptionMethodDictionary[selectedPayOptionKey];

                // Get default termination date in ISO string
                var defaultTerminationDate = defaultValues.terminationDate ? new Date(defaultValues.terminationDate).toISODateString() : null;

                // clear any messages in the message banner
                eventBanner.removeAllMessages();
                payOptionTerminationDateHidden.val(defaultTerminationDate);

                // set visibility of beneficiaries container
                visibility.setVisible(beneficiariesContainer, selectedPayOptionKey && selectedPayOptionMethod != codeValues.singleLife);
            }

            // On payOptionYearsInput change
            function payOptionYearsChange() {

                var yearsEntered = payOptionYearsInput.val() !== '';

                // If a value for years is entered, disable and clear the payments input
                payOptionPaymentsInput.prop('disabled', yearsEntered);
                if (yearsEntered) {
                    payOptionPaymentsInput.val("").clearErrors();                    
                }
            }

            // On payOptionPaymentsInput change
            function payOptionPaymentsChange() {

                var paymentsEntered = payOptionPaymentsInput.val() !== '';

                // If a value for payments is entered, disable and clear the years input
                payOptionYearsInput.prop('disabled', paymentsEntered);
                if (paymentsEntered) {
                    payOptionYearsInput.val("").clearErrors();                   
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);